import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { catchError, map, of } from 'rxjs'
import { Backend } from 'src/app/shared/enums/enums'
import { DdcLoggerService } from '../log/ddc-logger.service'

@Injectable({
  providedIn: 'root',
})
export class QuizService {
  constructor(
    private http: HttpClient,
    private logger: DdcLoggerService,
  ) {}

  get_quizzes(): any {
    this.logger.info('QUIZ | get_quizzes')
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http.get(`${Backend.HOST_CONTAINER + Backend.QUIZ}`, httpOptions).pipe(
      map((res: any) => {
        return res.results
      }),
      catchError((error: any) => {
        const errorMessage = error.error
        this.logger.error('QUIZ | get_quizzes | catchError | errorMessage: ' + errorMessage)
        return of(errorMessage)
      }),
    )
  }

  get_quizzes_page(username: string, page: number, pageSize: number): any {
    this.logger.info(
      'QUIZ | get_quizzes_page | username: ' +
        username +
        ' | page: ' +
        page +
        ' | pageSize: ' +
        pageSize,
    )
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http
      .get(
        `${Backend.HOST_CONTAINER + Backend.QUIZ}?username=${username}&page=${page}&pageSize=${pageSize}`,
        httpOptions,
      )
      .pipe(
        map((res: any) => {
          return res
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error('QUIZ | get_quizzes_page | catchError | errorMessage: ' + errorMessage)
          return of(errorMessage)
        }),
      )
  }

  get_searched_quizzes(target: string): any {
    this.logger.info('QUIZ/Search | get_searched_quizzes | target: ' + target)

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http
      .get(`${Backend.HOST_CONTAINER + Backend.QUIZ}search/?label=${target}`, httpOptions)
      .pipe(
        map((res: any) => {
          return res
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error(
            'QUIZ/Search | get_searched_quizzes | catchError | errorMessage: ' + errorMessage,
          )
          return of(errorMessage)
        }),
      )
  }

  get_pub_searched_quizzes(target: string): any {
    this.logger.info('QUIZ/Search All | get_pub_searched_quizzes | target: ' + target)

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http
      .get(`${Backend.HOST_CONTAINER + Backend.QUIZ}search/?all=true&label=${target}`, httpOptions)
      .pipe(
        map((res: any) => {
          return res
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error(
            'QUIZ/Search All | get_pub_searched_quizzes | catchError | errorMessage: ' +
              errorMessage,
          )
          return of(errorMessage)
        }),
      )
  }

  add_quiz(quiz: any): any {
    this.logger.info('QUIZ | add_quiz | quiz: ' + quiz)

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    const userData = {
      label: quiz,
    }

    return this.http.post(`${Backend.HOST_CONTAINER + Backend.QUIZ}`, userData, httpOptions).pipe(
      map((res: any) => {
        return { success: true, res: res }
      }),
      catchError((error: any) => {
        const errorMessage = error.error
        this.logger.error('QUIZ | add_quiz | catchError | errorMessage: ' + errorMessage)
        return of({ success: false, res: errorMessage })
      }),
    )
  }

  get_quiz(quiz_id: any): any {
    this.logger.info('QUIZ | get_quiz | quiz_id: ' + quiz_id)

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http
      .get(`${Backend.HOST_CONTAINER + Backend.QUIZ + quiz_id + '/'}`, httpOptions)
      .pipe(
        map((res: any) => {
          return { success: true, res: res }
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error('QUIZ | get_quiz | catchError | errorMessage: ' + errorMessage)
          return of({ success: false, res: errorMessage })
        }),
      )
  }

  submit_quiz(quiz_id: number, answers: { question_id: number; answer_id: number }[]): any {
    this.logger.info(
      'QUIZ | submit_quiz | quiz_id: ' + quiz_id + ' | answers: ' + JSON.stringify(answers),
    )

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    const submissionData = {
      quiz_id: quiz_id,
      answers: answers,
    }

    return this.http
      .post(
        `${Backend.HOST_CONTAINER + Backend.QUIZ}${quiz_id}/submit/`,
        submissionData,
        httpOptions,
      )
      .pipe(
        map((res: any) => {
          return { success: true, res: res }
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error('QUIZ | submit_quiz | catchError | errorMessage: ' + errorMessage)
          return of({ success: false, res: errorMessage })
        }),
      )
  }
}
